
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guestlogin",
      function () {
        return require("private-next-pages/guestlogin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guestlogin"])
      });
    }
  